// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator-item td {
    vertical-align: bottom;
}

.operator-item__operator-actions {
    display: flex;
    flex-direction: row;
    justify-content: end;
    min-width: 18rem;
    column-gap: 0.5rem;
}

.operator-item__operator-avatar {
    width: 6.2rem !important;
    height: 6.2rem !important;
    border-radius: 50%;
    margin-top: -1.5rem;
    margin-left: auto;
    margin-right: auto;
    display: block;
    cursor: pointer;
}

    .operator-item__operator-avatar svg {
        width: 100% !important;
        height: 100% !important;
    }

.operator-item__operator-avatar.online {
    border:rgb(0, 255, 0) 3px solid;
}

.operator-item__operator-avatar.pause {
    border: rgb(221, 221, 0) 3px solid;
}

.operator-item__operator-avatar.offline {
    border: red 3px solid;
}

.operator-item__status {
    font-size: medium;
    text-align: center;
}

.operator-item__button-discard {
    background-color: #d22e37;
}

.operator-item__btn {}

.operator-item__btn-delete {
    background-color: #d22e37;
}

.operator-item__btn-download {
    margin-left: .5rem;
}

.opertor-item__operator-type {
    display: block;
    color: black;
    outline: none;
    padding: 0;
    margin: 0;
    border: none;
    border-bottom: 1px solid #9e9e9e;
    transition: box-shadow .3s, border .3s;
    margin-bottom: 2rem !important;
}

.opertor-item__operator-type:focus {
    display: block;
    border: none;
    outline: none;
    border-bottom: 1px solid #26a69a;
    box-shadow: 0 1px 0 0 #26a69a;
}

.operator-item__operator-name {
    margin-bottom: 2rem !important;
    padding: 0 !important;
}

.operator-item__label {
    position:absolute;
    margin-top: -2rem;
    white-space: nowrap;
}

.operator-item__input_cell {
    padding-left: 0.8rem;
}

.operator-item .is-invalid {
    border-bottom: 1px solid red !important;
}

.operator-item .is-invalid:focus{
    box-shadow: 0 1px 0 0 red !important;
}

.operator-item__input-file-button {
    display: none;
}

.operator-item__upload-script-label {
    background-color: #26a69a;
    color: white;
    letter-spacing: .5px;
    font-size: 1.2rem;
    border: none;
    border-radius: 2px;
    border-bottom-right-radius: 0;
    padding: 0.6rem 1.6rem;
    cursor: pointer;
    text-transform: uppercase;
    /* width: 10rem; */
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
}

.operator-item__upload-script-label:hover {
    background-color: #2bbbad;
}

.uploaded-script-name {
    display: inline-block !important;
    color: black;
    min-width: 0;
    background: none;
    padding: 0.3rem 0.3rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.operator-item__input_cell div {
    display: flex;
}

.operator-item__input {
    border-bottom: 1px solid #ddd;
    padding-bottom: 0.3rem;
    margin-bottom: 2rem !important;
}

.operator-item-avatar-status {
    min-width: 6.2rem;
    padding-left: 1rem;
    padding-top: 2rem !important;
}

.operator-item__name {
    min-width: 15rem;
}

.operator-item__type {
    min-width: 15rem;
}

.operator-item__login {
    min-width: 20rem;
    max-width: 0;
}

.operator-item__password {
    min-width: 15rem;
}

.operator-item__enabled {
    min-width: 8rem;
}

.operator-item__operator-login {
    padding: 0 !important;
    margin-bottom: 2rem !important;
}

.operator-item__operator-password {
    padding: 0 !important;
    margin-bottom: 2rem !important;
}

.operator-item__operator-is-enabled {
    margin-bottom: 2.3rem !important;

}

.operator-avatar--disabled {
    pointer-events: none;
    opacity: 0.5; 

}

.operator-item__input_cell input[type="text"] {
    padding-bottom: 5px !important;
    height: auto;
    margin-top: 16px;
}

.opertor-item__operator-type{
padding-bottom: 5px !important;
height: auto !important;
}

.operator-item__input_cell input[type="password"] {
    padding-bottom: 5px !important;
    height: auto;
    margin-top: 16px;
}

.operator-item td {
    padding: 15px 5px 5px 5px;
}

.operator-item__cell-actions {
    vertical-align: middle !important;
    padding: 0px 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/operator/operators-main/operators-list/operator-item/OperatorItem.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;IAEI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;AAEJ;IACI,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;;AAErB;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,UAAU;IACV,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;;AAEpC;;AAEA;IACI,oBAAoB;IACpB,YAAY;;AAEhB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;AACA,8BAA8B;AAC9B,uBAAuB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;AAC/B","sourcesContent":[".operator-item td {\r\n    vertical-align: bottom;\r\n}\r\n\r\n.operator-item__operator-actions {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: end;\r\n    min-width: 18rem;\r\n    column-gap: 0.5rem;\r\n}\r\n\r\n.operator-item__operator-avatar {\r\n    width: 6.2rem !important;\r\n    height: 6.2rem !important;\r\n    border-radius: 50%;\r\n    margin-top: -1.5rem;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    display: block;\r\n    cursor: pointer;\r\n}\r\n\r\n    .operator-item__operator-avatar svg {\r\n        width: 100% !important;\r\n        height: 100% !important;\r\n    }\r\n\r\n.operator-item__operator-avatar.online {\r\n    border:rgb(0, 255, 0) 3px solid;\r\n}\r\n\r\n.operator-item__operator-avatar.pause {\r\n    border: rgb(221, 221, 0) 3px solid;\r\n}\r\n\r\n.operator-item__operator-avatar.offline {\r\n    border: red 3px solid;\r\n}\r\n\r\n.operator-item__status {\r\n    font-size: medium;\r\n    text-align: center;\r\n}\r\n\r\n.operator-item__button-discard {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.operator-item__btn {}\r\n\r\n.operator-item__btn-delete {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.operator-item__btn-download {\r\n    margin-left: .5rem;\r\n}\r\n\r\n.opertor-item__operator-type {\r\n    display: block;\r\n    color: black;\r\n    outline: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    border: none;\r\n    border-bottom: 1px solid #9e9e9e;\r\n    transition: box-shadow .3s, border .3s;\r\n    margin-bottom: 2rem !important;\r\n}\r\n\r\n.opertor-item__operator-type:focus {\r\n    display: block;\r\n    border: none;\r\n    outline: none;\r\n    border-bottom: 1px solid #26a69a;\r\n    box-shadow: 0 1px 0 0 #26a69a;\r\n}\r\n\r\n.operator-item__operator-name {\r\n    margin-bottom: 2rem !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n.operator-item__label {\r\n    position:absolute;\r\n    margin-top: -2rem;\r\n    white-space: nowrap;\r\n}\r\n\r\n.operator-item__input_cell {\r\n    padding-left: 0.8rem;\r\n}\r\n\r\n.operator-item .is-invalid {\r\n    border-bottom: 1px solid red !important;\r\n}\r\n\r\n.operator-item .is-invalid:focus{\r\n    box-shadow: 0 1px 0 0 red !important;\r\n}\r\n\r\n.operator-item__input-file-button {\r\n    display: none;\r\n}\r\n\r\n.operator-item__upload-script-label {\r\n    background-color: #26a69a;\r\n    color: white;\r\n    letter-spacing: .5px;\r\n    font-size: 1.2rem;\r\n    border: none;\r\n    border-radius: 2px;\r\n    border-bottom-right-radius: 0;\r\n    padding: 0.6rem 1.6rem;\r\n    cursor: pointer;\r\n    text-transform: uppercase;\r\n    /* width: 10rem; */\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    white-space: nowrap;\r\n}\r\n\r\n.operator-item__upload-script-label:hover {\r\n    background-color: #2bbbad;\r\n}\r\n\r\n.uploaded-script-name {\r\n    display: inline-block !important;\r\n    color: black;\r\n    min-width: 0;\r\n    background: none;\r\n    padding: 0.3rem 0.3rem;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.operator-item__input_cell div {\r\n    display: flex;\r\n}\r\n\r\n.operator-item__input {\r\n    border-bottom: 1px solid #ddd;\r\n    padding-bottom: 0.3rem;\r\n    margin-bottom: 2rem !important;\r\n}\r\n\r\n.operator-item-avatar-status {\r\n    min-width: 6.2rem;\r\n    padding-left: 1rem;\r\n    padding-top: 2rem !important;\r\n}\r\n\r\n.operator-item__name {\r\n    min-width: 15rem;\r\n}\r\n\r\n.operator-item__type {\r\n    min-width: 15rem;\r\n}\r\n\r\n.operator-item__login {\r\n    min-width: 20rem;\r\n    max-width: 0;\r\n}\r\n\r\n.operator-item__password {\r\n    min-width: 15rem;\r\n}\r\n\r\n.operator-item__enabled {\r\n    min-width: 8rem;\r\n}\r\n\r\n.operator-item__operator-login {\r\n    padding: 0 !important;\r\n    margin-bottom: 2rem !important;\r\n}\r\n\r\n.operator-item__operator-password {\r\n    padding: 0 !important;\r\n    margin-bottom: 2rem !important;\r\n}\r\n\r\n.operator-item__operator-is-enabled {\r\n    margin-bottom: 2.3rem !important;\r\n\r\n}\r\n\r\n.operator-avatar--disabled {\r\n    pointer-events: none;\r\n    opacity: 0.5; \r\n\r\n}\r\n\r\n.operator-item__input_cell input[type=\"text\"] {\r\n    padding-bottom: 5px !important;\r\n    height: auto;\r\n    margin-top: 16px;\r\n}\r\n\r\n.opertor-item__operator-type{\r\npadding-bottom: 5px !important;\r\nheight: auto !important;\r\n}\r\n\r\n.operator-item__input_cell input[type=\"password\"] {\r\n    padding-bottom: 5px !important;\r\n    height: auto;\r\n    margin-top: 16px;\r\n}\r\n\r\n.operator-item td {\r\n    padding: 15px 5px 5px 5px;\r\n}\r\n\r\n.operator-item__cell-actions {\r\n    vertical-align: middle !important;\r\n    padding: 0px 5px !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
